import { Action, AnyAction, combineReducers, Dispatch } from "redux";
import { all, fork } from "redux-saga/effects";

import { authSagas, AuthState } from "shared/store/auth";
import {
  profileReducer,
  authReducer,
  profileSagas,
  ProfileState,
} from "./profile";
import { promotionReducer, PromotionState } from "./promotion";
import { contentSagas, contentReducer, ContentState } from "./content";
import { pagesReducer, PagesState } from "shared/store/pages";

// The top-level state object
export interface ApplicationState {
  auth: AuthState;
  profile: ProfileState;
  promotion: PromotionState;
  content: ContentState;
  pages: PagesState;
}

// Additional props for connected React components. This prop is passed by default with `connect()`
export interface ConnectedReduxProps<A extends Action = AnyAction> {
  dispatch: Dispatch<A>;
}

// Whenever an action is dispatched, Redux will update each top-level application state property
// using the reducer with the matching name. It's important that the names match exactly, and that
// the reducer acts on the corresponding ApplicationState property type.
export const rootReducer = combineReducers<ApplicationState>({
  auth: authReducer,
  profile: profileReducer,
  promotion: promotionReducer,
  content: contentReducer,
  pages: pagesReducer,
});

// Here we use `redux-saga` to trigger actions asynchronously. `redux-saga` uses something called a
// "generator function", which you can read about here:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/function*
export function* rootSaga() {
  yield all([fork(authSagas), fork(profileSagas), fork(contentSagas)]);
}

export const SITE_KEY: string = process.env.REACT_APP_SITE_KEY!;
